export default __webpack_public_path__ + "images/KI.a3220d0.png";